import React from "react"

import { Swiper, SwiperSlide } from "swiper/react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

const WealthPartnerStatsSk = () => {
  const count = 3
  return (
    <React.Fragment>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        {Array(count)
          .fill()
          .map((_, index) => (
            <Skeleton
              key={`wp_stats_sk_${index}`}
              style={{
                minHeight: "150px",
                borderRadius: "20px",
              }}
            />
          ))}
      </div>
    </React.Fragment>
  )
}

export default WealthPartnerStatsSk
